import React, { Component } from 'react';
import { Link, Route, Switch, withRouter } from 'react-router-dom'
import { actionDashboardRequestSetup } from "../data/dashboard"
import { bindActionCreators } from "redux"
import { connect } from "react-redux"

const GroupItem = ({ name, lastUpdate }) => (
  <div>
    {name}:
    {lastUpdate.toString()},
    <Link to={`/group/${name}`}>Details</Link>
    RSS Feed: {`/feeds/userID/groups/${name}`}
  </div>
)

const GroupsRaw = ({ groups }) => (
  <div>
    {
      groups
        ? groups.map(x => (
          <GroupItem key={x.name} {...x}/>
        ))
        : <span>Loading...</span>
    }
  </div>
)

const Groups = connect(
  state => ({
    groups: state.firebase.receiveGroups
  })
)(GroupsRaw);

const GroupRaw = ({ name }) => (
  <div>
    Group {name}
  </div>
)

const Group = GroupRaw;

const NoMatch = () => (
  <div>
    404!
  </div>
)

class DashboardRaw extends Component {
  componentDidMount() {
    this.props.requestSetup();
  }

  render() {
    return (
      <div>
        Dashboard!
        Welcome!

        <Switch>
          <Route exact path='/' component={Groups}/>
          <Route path='/group/:groupName' render={({ match }) => (
            <Group name={match.params.groupName}/>
          )}/>
          <Route component={NoMatch}/>
        </Switch>
      </div>
    )
  }
}


export default withRouter(connect(
  null,
  dispatch => bindActionCreators({
    requestSetup: () => actionDashboardRequestSetup()
  }, dispatch)
)(DashboardRaw));



// WEBPACK FOOTER //
// ./src/components/Dashboard.js